import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment-mini'
import ImmutablePureComponent from 'react-immutable-pure-component'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { NavLink } from 'react-router-dom'
import {
  canShowChatMessage,
} from '../../../utils/can_show'
import { openPopover } from '../../../actions/popover'
import {
  showChatMessageAnyways,
} from '../../../actions/chat_messages'
import {
  BREAKPOINT_SMALL,
  CX,
  MODAL_COMPOSE,
  POPOVER_CHAT_MESSAGE_OPTIONS,
} from '../../../constants'
import { chatbotAccountIds, me } from '../../../initial_state'
import Icon from '../../../components/icon'
import Avatar from '../../../components/avatar'
import Button from '../../../components/button'
import Text from '../../../components/text'
import DotTextSeperator from '../../../components/dot_text_seperator'
import SensitiveMediaItem from '../../../components/sensitive_media_item'
import { makeGetChatMessage } from '../../../selectors'
import MediaGallery from '../../../components/media_gallery'
import StatusCard from '../../../components/status_card'
import { openModal } from '../../../actions/modal'
import WrappedBundle from '../../ui/util/wrapped_bundle'
import { GabAdChat } from '../../ui/util/async_components'
import { isTouch } from '../../../utils/is_mobile'

const isTouchable = isTouch()

class ChatMessageItem extends ImmutablePureComponent {

  state = {
    isHovering: false,
    isNewDay: false,
    isCloseToMyLast: false,
    isExpired: false,
    showMediaAnyways: false,
  }

  componentDidMount() {
    const {
      lastChatMessageSameSender,
      lastChatMessageDate,
      chatMessage,
    } = this.props
    if (lastChatMessageDate && chatMessage) {
      const createdAt = chatMessage.get('created_at')
      const isNewDay = moment(createdAt).format('L') !== moment(lastChatMessageDate).format('L')
      const isCloseToMyLast = moment(lastChatMessageDate).diff(createdAt, 'minutes') < 60 && lastChatMessageSameSender && !isNewDay
      this.setState({
        isNewDay,
        isCloseToMyLast,
      })
    }

    this._scheduleNextUpdate()
  }

  componentWillUnmount() {
    clearTimeout(this._timer)
  }

  _scheduleNextUpdate() {
    const { chatMessage } = this.props
    const { isExpired } = this.state
    if (!chatMessage || isExpired) return

    const expirationDate = chatMessage.get('expires_at')
    if (!expirationDate) return

    const msUntilExpiration = moment(expirationDate).valueOf() - moment().valueOf()
    if (msUntilExpiration > 86400000) return
    this._timer = setTimeout(() => {
      this.setState({ isExpired: true })
    }, msUntilExpiration);
  }

  handleOnMouseEnter = () => {
    this.setState({ isHovering: true }) 
  }

  handleOnMouseLeave = () => {
    this.setState({ isHovering: false })
  }

  handleMoreClick = () => {
    this.props.onOpenChatMessageOptionsPopover(this.props.chatMessageId, this.deleteBtnRef)
  }

  handleEmojiClick = () => {
    this.props.onOpenEmoji(this.emojiBtnRef)
  }

  handleOnShowAnyways = () => {
    this.props.onShowChatMessageAnyways(this.props.chatMessageId)
  }

  handleOnShowMediaAnyways = () => {
    this.setState({ showMediaAnyways: true })
  }

  handleOnClickChatbotShare = () => {
    const { onOpenCompose, chatMessage } = this.props
    onOpenCompose({
      initialText: `I just made this with @${chatMessage.getIn(['account', 'acct'])} `,
      initialMediaAttachments: chatMessage.get('media_attachments'),
      isSharingChatbotMedia: true,
    })
  }

  setDeleteBtnRef = (c) => {
    this.deleteBtnRef = c
  }

  setEmojiBtnRef = (c) => {
    this.emojiBtnRef = c 
  }

  render() {
    const {
      chatMessage,
      isHidden,
      lastChatMessageDate,
      isSmall,
      isRequest,
      onOpenMedia,
      isCompact,
    } = this.props
    const {
      isCloseToMyLast,
      isHovering,
      isNewDay,
      isExpired,
      showMediaAnyways,
    } = this.state

    if (!chatMessage || isExpired) return <div />

    const account = chatMessage.get('account')
    if (!account) return <div />

    const accountId = account.get('id')

    //If account is spam and not mine, hide
    if (chatMessage.getIn(['account', 'is_spam']) && accountId !== me) {
      return null
    }

    const csd = canShowChatMessage(chatMessage)

    const isChatbot = Array.isArray(chatbotAccountIds) && chatbotAccountIds.indexOf(parseFloat(account.get('id', -1))) > -1
    const content = { __html: chatMessage.get('text_html') }
    const hasContent = !!chatMessage.get('text') && chatMessage.get('text').length > 0
    const alt = account.get('id', null) === me
    const createdAt = chatMessage.get('created_at')
    const hasMedia = chatMessage.get('media_attachments').size > 0
    const hasManyMedia = chatMessage.get('media_attachments').size > 1
    const card = chatMessage.get('card')
    const avatarSize = isCompact ? 34 : isSmall ? 26 : 38
    const showWarning = !!csd.label && !csd.nulled
    const blurhashOnly = isRequest && !showMediaAnyways
    const replaceWithAd = hasContent && isChatbot && chatMessage.get('text') == "GabBotReplaceWithAdStatus"

    if (isHidden) {
      return (
        <React.Fragment>
          {account.get('display_name')}
          <div dangerouslySetInnerHTML={content} />
        </React.Fragment>
      )
    }

    const messageOuterContainerClasses = CX({
      d: 1,
      w100PC: 1,
      pb15: !isCompact,
      py2: isCompact,
    })

    const messageContainerClasses = CX({
      d: 1,
      flexRow: !alt || isCompact,
      flexRowReverse: alt && !isCompact,
      pb5: 1,
    })

    const messageInnerContainerClasses = CX({
      d: 1,
      maxW80PC: !isCompact,
      maxW100PC42PX: isCompact,
      w50PC: hasMedia && !hasManyMedia && !isSmall && !showWarning && !isCompact,
      w75PC: ((hasMedia && hasManyMedia) || !!card) && !isSmall && !showWarning && !isCompact,
      w80PC: hasMedia && isSmall && !showWarning && !isCompact,
      w100PC: isCompact,
      // bgTertiary: alt || csd.nulled || !!csd.label,
      // bgSecondary: !alt && !csd.nulled && !csd.label,
      ml10: 1,
      mr10: 1,
      overflowHidden: 1,
    })

    const messageInner2ContainerClasses = CX({
      d: 1,
      w100PC: 1,
      bgTransparent: isCompact,
      bgTertiary: (alt || csd.nulled || !!csd.label) && !isCompact,
      bgSecondary: !alt && !csd.nulled && !csd.label && !isCompact,
      radiusRounded: !isCompact,
      overflowHidden: 1,
    })
  
    const lowerContainerClasses = CX({
      d: 1,
      pt10: 1,
      posAbs: 1,
      bottom0: 1,
      right0: alt,
      left0: !alt,
      displayNone: !isHovering,
      pl50: !alt,
      pr50: alt,
    })

    const textContainerClasses = CX({
      d: 1,
      text: 1,
      cPrimary: 1,
      dangerousContent: 1,
      px15: !isCompact,
      py10: !isCompact,
    })

    const buttonContainerClasses = CX({
      d: 1,
      // displayNone: !isHovering && !isTouchable,
    })

    const buttonContainerInnerClasses = CX({
      d: 1,
      flexRow: !alt,
      flexRowReverse: alt,
    })

    const blurClass = blurhashOnly ? _s.blurImg : undefined
    const mediaContainerClasses = CX({
      d: 1,
      mt10: isCompact,
      maxW80PC: isCompact && !hasMedia,
      w100PC: isCompact && hasMedia,
      maxW340PX: isCompact && hasMedia,
      borderBottom1PX: hasContent && !isCompact,
      borderColorSecondary: hasContent && !isCompact,
    })

    const cardClasses = CX({
      d: 1,
      [blurClass]: 1,
      radiusSmall: isCompact,
      overflowHidden: isCompact,
      border1PX: isCompact,
      borderColorSecondary: isCompact,
    })

    const nulledContainerClasses = CX({
      d: 1,
      italic: isCompact,
      px15: !isCompact,
      py5: !isCompact,
      mt5: !isCompact,
      mb5: !isCompact,
    })

    const expirationDate = chatMessage.get('expires_at')
    let timeUntilExpiration
    if (!!expirationDate) {
      timeUntilExpiration = moment(expirationDate).fromNow()
    }

    const dates = (
      <Text size='extraSmall' color='tertiary' align={alt && !isCompact ? 'right' : 'left'}>
        {moment(createdAt).format('lll')}

        {
          !!expirationDate &&
          <React.Fragment>
            <DotTextSeperator />
            <Text size='extraSmall' color='tertiary' className={_s.ml5}>Expires {timeUntilExpiration}</Text>
            <Icon id='stopwatch' size='11px' className={[_s.d, _s.ml5, _s.displayInline, _s.cSecondary].join(' ')} />
          </React.Fragment>
        }
      </Text>
    )

    const buttons = (
      <>
        {/* <Button
          buttonRef={this.setEmojiBtnRef}
          onClick={this.handleEmojiClick}
          className={[_s.px10].join(' ')}
          color='tertiary'
          backgroundColor='none'
          icon='happy'
          iconSize='18px'
        /> */}
        <Button
          buttonRef={this.setDeleteBtnRef}
          onClick={this.handleMoreClick}
          className={[_s.px10].join(' ')}
          color='tertiary'
          backgroundColor='none'
          icon='ellipsis'
          title='More options'
          iconSize='18px'
        />
      </>
    )

    const showMediaBtn = (
      <div className={[_s.d, _s.posAbs, _s.top0, _s.left0, _s.right0, _s.bottom0, _s.aiCenter, _s.jcCenter, _s.bgPrimaryOpaque].join(' ')}>
        <Button
          onClick={this.handleOnShowMediaAnyways}
          color='white'
          backgroundColor='black'
          className={_s.bgSecondaryDark_onHover}
        >
          <Text color='inherit' weight='bold' size='medium'>
            Show media
          </Text>
        </Button>
      </div>
    )

    const mainWrapperClasses = CX({
      d: 1,
      w100PC: 1,
      pb5: 1,
      saveAreaInsetPT: 1,
      px15: !isCompact,
      px10: isCompact,
    })

    return (
      <div
        className={mainWrapperClasses}
        onMouseEnter={!csd.label && !csd.nulled ? this.handleOnMouseEnter : undefined}
        onMouseLeave={!csd.label && !csd.nulled ? this.handleOnMouseLeave : undefined}
      >
        {
          !!lastChatMessageDate && isNewDay &&
          <Text color='secondary' size='small' align='center' className={[_s.d, _s.py10].join(' ')}>
            {moment(createdAt).format('lll')}
          </Text>
        }

        { replaceWithAd && <WrappedBundle component={GabAdChat} /> }

        {
          !replaceWithAd &&

          <div className={messageOuterContainerClasses}>

            <div className={messageContainerClasses}>
                    
              <NavLink className={isSmall && !isCompact ? _s.mt5 : undefined} to={`/${account.get('acct')}`}>
                <Avatar account={account} size={avatarSize} isStatic />
              </NavLink>
              
              <div className={messageInnerContainerClasses}>
                <div className={messageInner2ContainerClasses}>
                  {
                    isCompact &&
                    <div className={[_s.d, _s.mb3, _s.flexRow, _s.aiCenter].join(' ')}>
                      <Text size='small' weight='medium' color={alt ? 'brand' : 'primary'}>@{account.get('acct')}</Text>
                      <Text size='small' color='secondary' className={[_s.ml5, _s.mr5].join(' ')}>·</Text>
                      {dates}
                      <Button
                        noClasses
                        buttonRef={this.setDeleteBtnRef}
                        onClick={this.handleMoreClick}
                        className={[_s.d, _s.ml5, _s.aiCenter, _s.jcCenter, _s.bgSubtle_onHover, _s.radiusSmall, _s.h14PX, _s.bgTransparent, _s.cSecondary, _s.cursorPointer, _s.pl5, _s.pr15].join(' ')}
                        icon='ellipsis'
                        title='More options'
                        iconSize='12px'
                      />
                    </div>
                  }

                  {
                    csd.nulled &&
                    <div className={nulledContainerClasses}>
                      <Text color='tertiary'>{csd.label}</Text>
                    </div>
                  }
                  {
                    showWarning &&
                    <SensitiveMediaItem
                      noPadding
                      onClick={this.handleOnShowAnyways}
                      message={csd.label}
                      btnTitle='View'
                    />
                  }

                  {
                    (!csd.label && !csd.nulled) && hasContent && isCompact && 
                    <div className={textContainerClasses} dangerouslySetInnerHTML={content} />
                  }

                  {
                    (!csd.label && !csd.nulled) && hasMedia &&
                    <div className={[mediaContainerClasses, _s.growOverflow].join(' ')}>
                      <MediaGallery
                        isNotification={isCompact}
                        onOpenMedia={onOpenMedia}
                        blurhashOnly={blurhashOnly}
                        media={chatMessage.get('media_attachments')}
                        isFromChat={true}
                      />
                      {blurhashOnly && showMediaBtn}
                    </div>
                  }

                  {
                    (!csd.label && !csd.nulled) && !!card && !hasMedia &&
                    <div className={mediaContainerClasses}>
                      <div className={cardClasses}>
                        <StatusCard
                          key={`${card.get('id')}-status-card`}
                          blurhashOnly={blurhashOnly}
                          card={card}
                          isBorderless
                          isImageSmall={isCompact}
                          isVertical={!isCompact}
                        />
                      </div>
                      {blurhashOnly && showMediaBtn}
                    </div>
                  }

                  {
                    (!csd.label && !csd.nulled) && hasContent && !isCompact && 
                    <div className={textContainerClasses} dangerouslySetInnerHTML={content} />
                  }
                </div>
                {
                  !alt && isChatbot && hasMedia &&
                  <div className={[_s.d, _s.w100PC, _s.mt10, _s.mb10].join(' ')}>
                    <Button
                      radiusSmall
                      backgroundColor='tertiary'
                      color='primary'
                      onClick={this.handleOnClickChatbotShare}
                    >
                      <Text color='inherit' align='center' weight='medium'>Share</Text>
                    </Button>
                  </div>
                }
                {/* <div className={[_s.d, _s.w100PC, _s.mt10, _s.mb10].join(' ')}>
                  <div>
                    <button className={[_s.d, _s.bgTransparent, _s.cursorPointer, _s.outlineNone, _s.font, _s.cPrimary, _s.border1PX, _s.borderColorSecondary, _s.fs14PX, _s.px10, _s.py5, _s.radiusSmall].join(' ')}>
                      👍 1
                    </button>
                  </div>
                </div> */}
              </div>

              {
                !isCompact &&
                <div className={buttonContainerClasses}>
                  <div className={buttonContainerInnerClasses}>
                    {buttons}
                  </div>
                </div>
              }
            </div>

            {!isCompact && <div className={lowerContainerClasses}>{dates}</div>}
          </div>
        }
      </div>
    )
  }

}

const mapStateToProps = (state, { lastChatMessageId, chatMessageId }) => ({
  chatMessage: makeGetChatMessage()(state, { id: chatMessageId }),
  lastChatMessageDate: lastChatMessageId ? state.getIn(['chat_messages', `${lastChatMessageId}`, 'created_at'], null) : null,
  lastChatMessageSameSender: lastChatMessageId ? state.getIn(['chat_messages', `${lastChatMessageId}`, 'from_account_id'], null) === state.getIn(['chat_messages', `${chatMessageId}`, 'from_account_id'], null) : false,
  isRequest: state.getIn(['chat_conversations', state.getIn(['chat_messages', chatMessageId, 'chat_conversation_id']), 'is_approved']) === false,
  isSmall: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_SMALL,
})

const mapDispatchToProps = (dispatch) => ({
  onOpenCompose: (opts) => {
    dispatch(openModal(MODAL_COMPOSE, opts))
  },
  onOpenMedia(media, index) {
    dispatch(openModal('MEDIA', { index, media }));
  },
  onOpenEmoji(targetRef) {
    dispatch(openPopover('EMOJI_PICKER', { targetRef }))
  },
  onOpenChatMessageOptionsPopover(chatMessageId, targetRef) {
    dispatch(openPopover(POPOVER_CHAT_MESSAGE_OPTIONS, {
      targetRef,
      chatMessageId,
      position: 'top',
    }))
  },
  onShowChatMessageAnyways(chatMessageId) {
    dispatch(showChatMessageAnyways(chatMessageId))
  },
})

ChatMessageItem.propTypes = {
  lastChatMessageId: PropTypes.string,
  lastChatMessageDate: PropTypes.string,
  lastChatMessageSameSender: PropTypes.bool,
  chatMessageId: PropTypes.string.isRequired,
  chatMessage: ImmutablePropTypes.map,
  isHidden: PropTypes.bool,
  alt: PropTypes.bool,
  isCompact: PropTypes.bool,
}

ChatMessageItem.defaultProps = {
  isCompact: false,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatMessageItem)
